'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var advanced = option.advanced,
      others = _objectWithoutProperties(option, ['advanced']);

  return _extends({
    name: '__style__',
    title: _index2.default.get({ id: 'stylePropertyStyleSetting', dm: '样式设置' }),
    display: 'accordion',
    collapsed: true,
    initialValue: {},
    tip: {
      url: 'https://lark.alipay.com/legao/help/design-tool-style',
      content: _index2.default.get({
        id: 'stylePropertyClickViewStyleSetter',
        dm: '点击 ? 查看样式设置器用法指南'
      })
    },

    setter: React.createElement(_visualengineUtils.StyleSetter, { advanced: advanced })
  }, others);
};

var _visualengineUtils = require('@ali/visualengine-utils');

var _index = require('./i18n/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

module.exports = exports['default'];